import { AppError, AppStatus, StoreFn } from "../../types";

export const init: StoreFn<undefined> = async (actions, payload, helpers) => {
  const app = helpers.injections.AppService;
  try {
    const status = await app.init();
    switch (status) {
      case AppStatus.Connected:
        actions.setStatus(AppStatus.Connected);
        actions.setMintedCount(app.mintedCount);
        if (app.currentService?.tokenPrice)
          actions.setTokenPrice(app.currentService?.tokenPrice);
        if (app.currentService?.wallet)
          actions.setWallet(app.currentService?.wallet);
        actions.setStatus(AppStatus.Connected);
        break;
      case AppStatus.Disconnected:
        actions.setStatus(AppStatus.Disconnected);
        break;
      case AppStatus.NotStarted:
        actions.setStatus(AppStatus.NotStarted);
        break;
      default:
        actions.setStatus(AppStatus.Disconnected);
        break;
    }
  } catch (e: any) {
    switch (e?.message) {
      case AppError.NoEthereum:
        actions.setErrors([AppError.NoEthereum]);
        break;
      case AppError.WrongNetwork:
        actions.setErrors([AppError.WrongNetwork]);
        break;
      default:
        actions.setErrors([AppError.UnrecognizedError]);
        break;
    }
  }
};
